export const da = {
  main: {
    color_hex: 'Farve i hexadecimal notation, start med #',
    language: 'Dansk',
    restricted_field_name: 'Dette feltnavn er reserveret og kan ikke bruges',
    asset_type_required: 'Vælg mindst én aktivtype eller gør feltet globalt',
    searchbar: 'Søg (min. 3 tegn)',
    title: 'Admin',
    logout: 'Log ud',
    english: 'Engelsk',
    dutch: 'Hollandske',
    french: 'Fransk',
    spanish: 'Spansk',
    danish: 'Dansk',
    italian: 'Italiensk',
    romanian: 'Rumænsk',
    norwegian: 'Norsk',
    german: 'Tysk',
    drop_image: 'Slip dit billede her',
  },
  ra: {
    tree: {
      add_child_node: 'Tilføj underkategori',
      add_node_after: 'Tilføj kategori efter',
      add_node_before: 'Tilføj kategori for',
      close: 'Tæt',
      expand: 'At åbne',
    },
  },
  resources: {
    categories: {
      name: 'Kategori |||| Kategorier',
      fields: {
        name: 'Kategorinavn',
      },
    },
    users: {
      name: 'Bruger |||| Brugere',
      fields: {
        category: 'Kategori',
        connection: 'Forbindelse',
        email: 'E-mail',
        familyName: 'Familie navn',
        firstName: 'Fornavn',
        language: 'Sprog',
        userRoles: 'Roller',
      },
    },
    priorities: {
      name: 'Prioritet |||| Prioriteter',
    },
    branding: {
      name: 'Logo',
    },
    invitations: {
      name: 'Invitation |||| Invitationer',
      fields: {
        email: 'E-mail',
      },
    },
    'asset-types': {
      name: 'Aktivtype |||| Aktivtyper',
      fields: {
        name: 'Navn',
      },
    },
    'asset-statuses': {
      name: 'Aktivstatus |||| Aktivstatusser',
      fields: {
        name: 'Navn',
      },
    },
    'asset-custom-fields': {
      name: 'Brugerdefineret felt |||| Brugerdefinerede felter',
      fields: {
        name: 'Navn',
        globalField: 'Global (alle aktivtyper)',
        assetTypeIds: 'Aktivtyper',
      },
    },
  },
}
